import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-content-reviews.loaders';
import { converters } from './admin-content-reviews.converters';
import { AdminContentReviewsFilters } from './admin-content-reviews.types';

export const adminContentReviewsKeys = queryKeyFactory('admin-content-reviews');

export const useAdminContentReviews = (
  filters: Partial<AdminContentReviewsFilters> = {},
) => {
  return useQuery({
    queryKey: adminContentReviewsKeys.list(filters),
    queryFn: () => loaders.getContentReviews({ filters }),
    select: converters.getContentReviews,
    keepPreviousData: true,
  });
};

export const useAdminContentReviewsPendingCount = (
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: adminContentReviewsKeys.list('pending-count'),
    queryFn: loaders.getPendingCount,
    select: converters.getPendingCount,
    ...options,
  });
};

export const useAdminContentReview = (reviewId: string) => {
  return useQuery({
    queryKey: adminContentReviewsKeys.detail(reviewId),
    queryFn: () => loaders.getContentReview({ reviewId }),
    select: converters.getContentReview,
    enabled: !!reviewId,
  });
};

export const usePendingContentReviewForEntity = (
  liveEntityId: string,
  enabled = true,
) => {
  const filters: Partial<AdminContentReviewsFilters> = {
    liveEntityId,
    status: ['pending'],
    page: 1,
    pageSize: 1,
  };

  return useQuery({
    queryKey: adminContentReviewsKeys.list('by-live-entity', filters),
    queryFn: () => loaders.getContentReviews({ filters }),
    select: (response) => converters.getContentReviews(response).items[0],
    enabled: enabled && !!liveEntityId,
  });
};
